import gql from "graphql-tag";
import { useQuery } from "react-apollo-hooks";
import useGlobalState from "../../useGlobalState";

const query = gql`
  query staffAbsencesValidate($where: StaffAbsencesValidateInput) {
    validate: staffAbsencesValidate(where: $where) {
      validate
      executionCode
      absencesType
      validateActivityCount
    }
  }
`;

const INITIAL_TIME = 10;
const MS_PER_MINUTE = 60 * 1000;

const getValidatedTime = value => {
  if (value === null || value === undefined) {
    return INITIAL_TIME * MS_PER_MINUTE;
  }

  const parsedValue = Number(
    String(value)
      .trim()
      .replace(",", ".")
  );

  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return INITIAL_TIME * MS_PER_MINUTE;
  }

  return Math.round(parsedValue * MS_PER_MINUTE);
};

export const useAbsenceStaffHook = () => {
  const user = useGlobalState("user");
  const pollIntervalTime = useGlobalState(
    "option.cuidados_-_tiempo_inactivo_de_consulta_(minutos)"
  );

  const pollInterval = getValidatedTime(pollIntervalTime);

  const sessionProfile = JSON.parse(sessionStorage.getItem("centerSelected"));

  const shouldValidateActivity = Boolean(
    user?.isStaff && user?.profile?.isActivityValidation
  );

  const { data: { validate } = {}, loading, refetch } = useQuery(query, {
    skip: !shouldValidateActivity,
    // pollInterval: 20000,
    pollInterval,
    fetchPolicy: "network-only",
    variables: {
      where: {
        centerId: sessionProfile?.id || null
      }
    }
  });

  return {
    isAbsent: Boolean(validate?.validate),
    executionCode: validate?.executionCode,
    absencesType: validate?.absencesType,
    validateActivityCount: validate?.validateActivityCount || 0,
    loading,
    refetch
  };
};
